import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.scout-report-point-measurement-form', () => {
  void import('./internal/scout-report-point-measurement-form')
    .then(({ default: Component }) => Component());
});
